import React from 'react';
import DocumentStoreService from '@services/documentStore/DocumentStoreService';
import useServiceHook from '@hooks/useServiceHook';
import CircularSpinner from "@components/spinners/Circular/Circular";
import DocumentStoreRecord from './DocumentStoreRecord';

const LoadingSpinner = () => (
    <div data-testid="loading-spinner" style={{ display: 'flex', justifyContent: 'center', margin: '15vh' }}>
        {<CircularSpinner />}
    </div>
)

export type IdentityVerificationCheckDocumentsProps = {
    identityVerificationCheckReferenceId: string
    documentTypes?: string[]
};

const documentSorting = new Map([
    // Document 1
    ['Driver Licence', 1],
    // Document 2
    ['Passport', 2],
    ['Credit or Debit Card', 2],
    ['ID Card', 2],
    ['Medicare Card', 2],
    ['PCO', 2],
    // Proof of Address
    ['Utility Bill', 3],
    ['Bank Statement', 3],
    ['Credit Card Statement', 3],
    ['Rental Agreement', 3],
    // Driver Authority Card
    ['Queensland Driver Authority Card', 4],
    // Identity Verification Check Report
    ['Identity Verification Check Report', 10]
])

function SortDocument(doc1: any, doc2: any) {
    if (documentSorting.get(doc1['document_type']) == undefined) {
        return 1
    }

    if (documentSorting.get(doc2['document_type']) == undefined) {
        return -1
    }

    // @ts-ignore
    return documentSorting.get(doc1['document_type']) - documentSorting.get(doc2['document_type'])
}

export default function IdentityVerificationCheckDocuments(props: IdentityVerificationCheckDocumentsProps) {
    const [loading, error, errMsg, result] = useServiceHook(
        DocumentStoreService.getIdentityVerificationCheckDocuments,
        [props.identityVerificationCheckReferenceId],
        true,
        [],
        undefined,
        [props.documentTypes]
    );

    if (!loading && result && result['identity_verification_check_documents']) {
        result['identity_verification_check_documents'].sort(SortDocument);
        console.log(result)
    }

    return (
        <>
            {loading && <LoadingSpinner />}

            {
                !loading && result && result['identity_verification_check_documents'] &&
                <div data-testid='identityVerificationCheckDocumentsListing'>
                    {
                        result['identity_verification_check_documents'].map(
                            (document: any, index: number) => (
                                <div style={{ paddingTop: '1.5vh' }} key={`identityVerificationCheckDocument-div-${index}`}>
                                    <DocumentStoreRecord
                                        documentStoreRecordId={document['document_store_record_id']}
                                        description={document['description']}
                                        documentType={document['document_type']}
                                        documentNumber={document['document_number']}
                                        expiryDate={document['expiry_date'] ? new Date(document['expiry_date']) : undefined}
                                        files={document['files']}
                                        additionalData={document['additional_data']}
                                    />
                                </div>
                            )
                        )
                    }
                </div>
            }
        </>
    )
}